$(document).ready(() => {

    // < Home Events >
    const tg_home_1 = { 'eventCategory': 'Home', 'eventAction': 'Click', 'eventLabel': '01. Colombia Retoma Su Rumbo', 'eventValue': '', 'event': 'eventClick' };
    const tg_home_2 = { 'eventCategory': 'Home', 'eventAction': 'Click', 'eventLabel': '02. Nuestra Mejor Selección', 'eventValue': '', 'event': 'eventClick' };
    const tg_home_3 = { 'eventCategory': 'Home', 'eventAction': 'Click', 'eventLabel': '03. Visión Colombia', 'eventValue': '', 'event': 'eventClick' };
    const tg_home_4 = { 'eventCategory': 'Home', 'eventAction': 'Click', 'eventLabel': '04. Inversión Responsable y Sostenible', 'eventValue': '', 'event': 'eventClick' };
    // </ Home Events >



    // < Cap-1 Events >
    const tg_c1_1 = { 'eventCategory': '01 .Colombia Retoma Su Rumbo', 'eventAction': 'Click', 'eventLabel': '01.1 Introducción', 'eventValue': '', 'event': 'eventClick' };
    const tg_c1_2 = { 'eventCategory': '01 .Colombia Retoma Su Rumbo', 'eventAction': 'Click', 'eventLabel': '01.2 Un Mundo Afectado por el Covid-19', 'eventValue': '', 'event': 'eventClick' };
    const tg_c1_3 = { 'eventCategory': '01 .Colombia Retoma Su Rumbo', 'eventAction': 'Click', 'eventLabel': '01.3 Principales Factores de Riesgo', 'eventValue': '', 'event': 'eventClick' };
    const tg_c1_4 = { 'eventCategory': '01 .Colombia Retoma Su Rumbo', 'eventAction': 'Click', 'eventLabel': '01.4 Las Medidas para Enfrentar el Covid-19 en el Mundo', 'eventValue': '', 'event': 'eventClick' };
    const tg_c1_5 = { 'eventCategory': '01 .Colombia Retoma Su Rumbo', 'eventAction': 'Click', 'eventLabel': '01.5 Sector Externo', 'eventValue': '', 'event': 'eventClick' };
    const tg_c1_6 = { 'eventCategory': '01 .Colombia Retoma Su Rumbo', 'eventAction': 'Click', 'eventLabel': '01.6 Inflación', 'eventValue': '', 'event': 'eventClick' };
    const tg_c1_7 = { 'eventCategory': '01 .Colombia Retoma Su Rumbo', 'eventAction': 'Click', 'eventLabel': '01.7 Proyecciones de Crecimiento', 'eventValue': '', 'event': 'eventClick' };
    const tg_c1_8 = { 'eventCategory': '01 .Colombia Retoma Su Rumbo', 'eventAction': 'Click', 'eventLabel': '01.8 Política Monetaria', 'eventValue': '', 'event': 'eventClick' };
    const tg_c1_9 = { 'eventCategory': '01 .Colombia Retoma Su Rumbo', 'eventAction': 'Click', 'eventLabel': '01.9 Tasa de Cambio', 'eventValue': '', 'event': 'eventClick' };
    const tg_c1_10 = { 'eventCategory': '01 .Colombia Retoma Su Rumbo', 'eventAction': 'Click', 'eventLabel': '01.10 Finanzas Públicas', 'eventValue': '', 'event': 'eventClick' };
    const tg_c1_11 = { 'eventCategory': '01 .Colombia Retoma Su Rumbo', 'eventAction': 'Click', 'eventLabel': '01.11 Resumen: Perspectivas Macroeconómicas 20/21', 'eventValue': '', 'event': 'eventClick' };
    const tg_c1_12 = { 'eventCategory': '01 .Colombia Retoma Su Rumbo', 'eventAction': 'Descarga', 'eventLabel': '01.12 Colombia Retoma Su Rumbo - Descarga', 'eventValue': '', 'event': 'eventClick' };
    // </ Cap-1 Events >


    // < Cap-2 Events >
    const tg_c2_1 = { 'eventCategory': '02. Nuestra Mejor Selección', 'eventAction': 'Click', 'eventLabel': '02.1 Introducción', 'eventValue': '', 'event': 'eventClick' };
    const tg_c2_2 = { 'eventCategory': '02. Nuestra Mejor Selección', 'eventAction': 'Click', 'eventLabel': '02.2 Resumen precios objetivos reco', 'eventValue': '', 'event': 'eventClick' };
    const tg_c2_3 = { 'eventCategory': '02. Nuestra Mejor Selección', 'eventAction': 'Click', 'eventLabel': '02.3 Metodología de Valoración', 'eventValue': '', 'event': 'eventClick' };
    const tg_c2_4 = { 'eventCategory': '02. Nuestra Mejor Selección', 'eventAction': 'Click', 'eventLabel': '02.4 2020: Un Impacto Negativo No Previsto', 'eventValue': '', 'event': 'eventClick' };
    const tg_c2_5 = { 'eventCategory': '02. Nuestra Mejor Selección', 'eventAction': 'Click', 'eventLabel': '02.5 2021: Hacia una Gradual Recuperación', 'eventValue': '', 'event': 'eventClick' };
    const tg_c2_6 = { 'eventCategory': '02. Nuestra Mejor Selección', 'eventAction': 'Click', 'eventLabel': '02.6 Retos y Oportunidades', 'eventValue': '', 'event': 'eventClick' };
    const tg_c2_7 = { 'eventCategory': '02. Nuestra Mejor Selección', 'eventAction': 'Click', 'eventLabel': '02.7 Una Mirada al Largo Plazo', 'eventValue': '', 'event': 'eventClick' };
    const tg_c2_8 = { 'eventCategory': '02. Nuestra Mejor Selección', 'eventAction': 'Click', 'eventLabel': '02.8 Nuestra Mejor Selección', 'eventValue': '', 'event': 'eventClick' };
    const tg_c2_9 = { 'eventCategory': '02. Nuestra Mejor Selección', 'eventAction': 'Descarga', 'eventLabel': '02.9 Nuestra Mejor Selección - Descarga', 'eventValue': '', 'event': 'eventClick' };
    // </ Cap-2 Events >


    // < Cap-3 Events >
    const tg_c3_1 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'Click', 'eventLabel': '03.1 Introducción', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_2 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'Click', 'eventLabel': '03.2 Consumo', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_3 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'Click', 'eventLabel': '03.2.1 Grupo Nutresa', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_4 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'Click', 'eventLabel': '03.2.2 Terpel', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_5 = {'eventCategory': '03. Visión Colombia','eventAction': 'click','eventLabel': '03.3 Construcción y Materiales','eventValue': '','event': 'eventClick'};
    const tg_c3_6 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.3.1 Cementos Argos', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_7 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.3.2 Conconcreto', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_8 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.3.3 El Condor', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_9 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.3.4 Grupo Argos', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_10 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.4 Financiero', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_11 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.4.1 Banco de Bogotá', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_12 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.4.2 Bancolombia', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_13 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.4.3 Corficolombiana', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_14 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.4.4 Grupo Aval', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_15 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.4.5 Grupo Sura', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_16 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.5 Inmobiliario', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_17 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.5.1 PEI', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_18 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.6 Petróleo y Minería', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_19 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.6.1 Ecopetrol', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_20 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.6.2 Mineros', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_21 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.7 Servicios Públicos', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_22 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.7.1 Celsia', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_23 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.7.2 Grupo Energía Bogotá', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_24 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.7.3 ISA', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_25 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'click', 'eventLabel': '03.7.4 Promigas', 'eventValue': '', 'event': 'eventClick' };
    const tg_c3_26 = { 'eventCategory': '03. Visión Colombia', 'eventAction': 'Descarga', 'eventLabel': '03.8 Visión Colombia - Descarga', 'eventValue': '', 'event': 'eventClick' };
    // </ Cap-3 Events >


    // < Cap-4 Events >
    const tg_c4_1 = { 'eventCategory': '04. Inversión Responsable y Sostenible', 'eventAction': 'Click', 'eventLabel': '04.1 Inversión Responsable y Sostenible', 'eventValue': '', 'event': 'eventClick' };
    // </ Cap-4 Events >


    // < Networks-1 Events >
    const tg_nt1_1 = { 'eventCategory': 'Redes Davivienda', 'eventAction': 'Link', 'eventLabel': 'Davivienda Facebook', 'eventValue': '', 'event': 'eventClick' };
    const tg_nt1_2 = { 'eventCategory': 'Redes Davivienda', 'eventAction': 'Link', 'eventLabel': 'Davivienda Twitter', 'eventValue': '', 'event': 'eventClick' };
    const tg_nt1_3 = { 'eventCategory': 'Redes Davivienda', 'eventAction': 'Link', 'eventLabel': 'Davivienda Instagram', 'eventValue': '', 'event': 'eventClick' };
    const tg_nt1_4 = { 'eventCategory': 'Redes Davivienda', 'eventAction': 'Link', 'eventLabel': 'Davivienda Youtube', 'eventValue': '', 'event': 'eventClick' };
    const tg_nt1_5 = { 'eventCategory': 'Redes Davivienda', 'eventAction': 'Link', 'eventLabel': 'Portal Davivienda.com', 'eventValue': '', 'event': 'eventClick' };
    const tg_nt1_6 = { 'eventCategory': 'Redes Davivienda', 'eventAction': 'Link', 'eventLabel': 'Davivienda LinkedIn', 'eventValue': '', 'event': 'eventClick' };
    // </ Networks-1 Events >


    // < Networks-2 Events >
    const tg_nt2_1 = { 'eventCategory': 'Redes Corredores', 'eventAction': 'Link', 'eventLabel': 'Corredores Twitter', 'eventValue': '', 'event': 'eventClick' };
    const tg_nt2_2 = { 'eventCategory': 'Redes Corredores', 'eventAction': 'Link', 'eventLabel': 'Corredores Youtube', 'eventValue': '', 'event': 'eventClick' };
    const tg_nt2_3 = { 'eventCategory': 'Redes Corredores', 'eventAction': 'Link', 'eventLabel': 'Portal Daviviendacorredores.com', 'eventValue': '', 'event': 'eventClick' };
    const tg_nt2_4 = { 'eventCategory': 'Redes Corredores', 'eventAction': 'Link', 'eventLabel': 'Corredores LinkedIn', 'eventValue': '', 'event': 'eventClick' };
    // </ Networks-2 Events >


    jQuery.fn.bookgtm = function (options) {
        if (options) {
            $(this).click(function (e) {
                const type = $(this).attr('data-tgm-type');

                if (type) {
                    if (type === 'blank') {
                        e.preventDefault();
                        dataLayer.push(options);
                        window.open($(this).attr('href'), '_blank');
                    } else if (type === 'self') {
                        e.preventDefault();
                        dataLayer.push(options);
                        window.open($(this).attr('href'), '_self');
                    }
                } else {
                    dataLayer.push(options);
                }
            });
        }
    }

    const to_runs = $(`[data-tgm="analitic"]`);

    jQuery.each(to_runs, function () {
        const attribute = $(this).attr('data-tgm-tag');

        if (attribute) {
            switch (attribute) {
                case 'tg_home_1':
                    $(this).bookgtm(tg_home_1);
                    break;
                case 'tg_home_2':
                    $(this).bookgtm(tg_home_2);
                    break;
                case 'tg_home_3':
                    $(this).bookgtm(tg_home_3);
                    break;
                case 'tg_home_4':
                    $(this).bookgtm(tg_home_4);
                    break;
                case 'tg_c1_1':
                    $(this).bookgtm(tg_c1_1);
                    break;
                case 'tg_c1_2':
                    $(this).bookgtm(tg_c1_2);
                    break;
                case 'tg_c1_3':
                    $(this).bookgtm(tg_c1_3);
                    break;
                case 'tg_c1_4':
                    $(this).bookgtm(tg_c1_4);
                    break;
                case 'tg_c1_5':
                    $(this).bookgtm(tg_c1_5);
                    break;
                case 'tg_c1_6':
                    $(this).bookgtm(tg_c1_6);
                    break;
                case 'tg_c1_7':
                    $(this).bookgtm(tg_c1_7);
                    break;
                case 'tg_c1_8':
                    $(this).bookgtm(tg_c1_8);
                    break;
                case 'tg_c1_9':
                    $(this).bookgtm(tg_c1_9);
                    break;
                case 'tg_c1_10':
                    $(this).bookgtm(tg_c1_10);
                    break;
                case 'tg_c1_11':
                    $(this).bookgtm(tg_c1_11);
                    break;
                case 'tg_c1_12':
                    $(this).bookgtm(tg_c1_12);
                    break;
                case 'tg_c2_1':
                    $(this).bookgtm(tg_c2_1);
                    break;
                case 'tg_c2_2':
                    $(this).bookgtm(tg_c2_2);
                    break;
                case 'tg_c2_3':
                    $(this).bookgtm(tg_c2_3);
                    break;
                case 'tg_c2_4':
                    $(this).bookgtm(tg_c2_4);
                    break;
                case 'tg_c2_5':
                    $(this).bookgtm(tg_c2_5);
                    break;
                case 'tg_c2_6':
                    $(this).bookgtm(tg_c2_6);
                    break;
                case 'tg_c2_7':
                    $(this).bookgtm(tg_c2_7);
                    break;
                case 'tg_c2_8':
                    $(this).bookgtm(tg_c2_8);
                    break;
                case 'tg_c2_9':
                    $(this).bookgtm(tg_c2_9);
                    break;
                case 'tg_c3_1':
                    $(this).bookgtm(tg_c3_1);
                    break;
                case 'tg_c3_2':
                    $(this).bookgtm(tg_c3_2);
                    break;
                case 'tg_c3_3':
                    $(this).bookgtm(tg_c3_3);
                    break;
                case 'tg_c3_4':
                    $(this).bookgtm(tg_c3_4);
                    break;
                case 'tg_c3_5':
                    $(this).bookgtm(tg_c3_5);
                    break;
                case 'tg_c3_6':
                    $(this).bookgtm(tg_c3_6);
                    break;
                case 'tg_c3_7':
                    $(this).bookgtm(tg_c3_7);
                    break;
                case 'tg_c3_8':
                    $(this).bookgtm(tg_c3_8);
                    break;
                case 'tg_c3_9':
                    $(this).bookgtm(tg_c3_9);
                    break;
                case 'tg_c3_10':
                    $(this).bookgtm(tg_c3_10);
                    break;
                case 'tg_c3_11':
                    $(this).bookgtm(tg_c3_11);
                    break;
                case 'tg_c3_12':
                    $(this).bookgtm(tg_c3_12);
                    break;
                case 'tg_c3_13':
                    $(this).bookgtm(tg_c3_13);
                    break;
                case 'tg_c3_14':
                    $(this).bookgtm(tg_c3_14);
                    break;
                case 'tg_c3_15':
                    $(this).bookgtm(tg_c3_15);
                    break;
                case 'tg_c3_16':
                    $(this).bookgtm(tg_c3_16);
                    break;
                case 'tg_c3_17':
                    $(this).bookgtm(tg_c3_17);
                    break;
                case 'tg_c3_18':
                    $(this).bookgtm(tg_c3_18);
                    break;
                case 'tg_c3_19':
                    $(this).bookgtm(tg_c3_19);
                    break;
                case 'tg_c3_20':
                    $(this).bookgtm(tg_c3_20);
                    break;
                case 'tg_c3_21':
                    $(this).bookgtm(tg_c3_21);
                    break;
                case 'tg_c3_22':
                    $(this).bookgtm(tg_c3_22);
                    break;
                case 'tg_c3_23':
                    $(this).bookgtm(tg_c3_23);
                    break;
                case 'tg_c3_24':
                    $(this).bookgtm(tg_c3_24);
                    break;
                case 'tg_c3_25':
                    $(this).bookgtm(tg_c3_25);
                    break;
                case 'tg_c3_26':
                    $(this).bookgtm(tg_c3_26);
                    break;
                case 'tg_c4_1':
                    $(this).bookgtm(tg_c4_1);
                    break;
                case 'tg_nt1_1':
                    $(this).bookgtm(tg_nt1_1);
                    break;
                case 'tg_nt1_2':
                    $(this).bookgtm(tg_nt1_2);
                    break;
                case 'tg_nt1_3':
                    $(this).bookgtm(tg_nt1_3);
                    break;
                case 'tg_nt1_4':
                    $(this).bookgtm(tg_nt1_4);
                    break;
                case 'tg_nt1_5':
                    $(this).bookgtm(tg_nt1_5);
                    break;
                case 'tg_nt1_6':
                    $(this).bookgtm(tg_nt1_6);
                    break;
                case 'tg_nt2_1':
                    $(this).bookgtm(tg_nt2_1);
                    break;
                case 'tg_nt2_2':
                    $(this).bookgtm(tg_nt2_2);
                    break;
                case 'tg_nt2_3':
                    $(this).bookgtm(tg_nt2_3);
                    break;
                case 'tg_nt2_4':
                    $(this).bookgtm(tg_nt2_4);
                    break;
                default:
                    return false;
            }
        }
    });
});
